<app-service-child-list [object]="object" [key]="key" [extraData]="extraData">
  <div *app-content-loader="let item">
    {{ item['first_name'] }} {{ item['last_name'] }}
  </div>
</app-service-child-list>
